import {
  AddressQuestion,
  BooleanQuestion,
  PhoneQuestion,
  Question,
  Questions,
} from '../../classes/question'
import { Countries } from '../../data'

export const getEmployerQuestions = (customQuestions: Questions): Questions => [
  new BooleanQuestion({
    label: 'patient-intake.employer-section.field-employer-question',
    key: 'isEmployed',
    required: true,
    ifQuestions: getQuestions(customQuestions),
    ifNoProceed: true,
    introText: 'patient-intake.employer-section.intro-text',
  }),
]

const getQuestions = (customQuestions: Questions): Questions => [
  new Question({
    label: 'patient-intake.employer-section.field-employer-name',
    key: 'employerName',
    flex: '50',
    required: true,
  }),

  // new DropdownQuestion({
  //   label: 'Employment Status',
  //   key: 'employmentStatus',
  //   flex: '50',
  //   required: true,
  //   options: EmploymentStatuses,
  // }),

  new PhoneQuestion({
    label: 'patient-intake.employer-section.field-employer-phone',
    key: 'employerPhoneNumber',
    flex: '50',
    required: true,
  }),

  new AddressQuestion({
    label: 'patient-intake.employer-section.field-employer-address',
    key: 'employerAddress',
    required: false, // TODO: not sure how necessary required this truly is
    options: Countries,
  }),

  ...customQuestions,
]
